import TRAVELER from "../../common/constants/ISOS/ISOSTraveler.js";

import {
  ENDPOINT_TRAVEL_TRACKER_TRAVELERS,
  ENDPOINT_TRAVEL_TRACKER_PROFILES,
} from "@/common/constants/api";
import { encodeAllURLParameters } from "@/common/api.utilities";
import { httpGet, httpPost } from "@/services/api.service";
import { MODULE_PREFIX_USER } from "@/store";
import { SAVE_PREFERENCES } from "@/store/actions.type";
import lodashCloneDeep from "lodash/cloneDeep";
import lodashGet from "lodash/get";

export { _getTravelers as getTravelers };
export { _getProfiles as getProfiles };
export { _travelersToFeatures as travelersToFeatures };
export { _loadTravelerIcon as loadTravelerIcon };
export { TRAVELER_ICON as travelerIcon };
export { _getPreference as getPreference };
export { _savePreference as savePreference };

const TRAVELER_ICON = "ISOS_travelers_generic";

const _getTravelers = async (params) => {
  let travelers;
  try {
    // AVAILABLE PARAMS TO USE
    // bounds, start, end
    let url = encodeAllURLParameters({
      baseEndpoint: ENDPOINT_TRAVEL_TRACKER_TRAVELERS,
      params: params,
      isTravelTracker: true,
    });

    const RESULT = await httpGet({ url: url });

    const { data } = JSON.parse(RESULT);
    if (data) {
      travelers = data.data;
    }

    return travelers;
  } catch (error) {
    console.log("error", error);
    await Promise.reject(
      "Issue getting travelers in travelTracker.service.js: " +
        JSON.stringify(error)
    );
  } finally {
    travelers = null;
  }
};

const _getProfiles = async (params) => {
  let profiles;
  try {
    let url = ENDPOINT_TRAVEL_TRACKER_PROFILES;

    let bodyData = params;

    const RESULT = await httpPost({ url: url, data: bodyData });

    const { data } = JSON.parse(RESULT);
    if (data) {
      profiles = data;
    }

    return profiles;
  } catch (error) {
    console.log("error", error);
    await Promise.reject(
      "Issue getting profiles in travelTracker.service.js: " +
        JSON.stringify(error)
    );
  } finally {
    profiles = null;
  }
};

const _travelersToFeatures = (data) => {
  let res = [];
  if (data) {
    let features = data;

    for (let i = 0; i < features.length; i++) {
      let cur = features[i];
      cur.icon = TRAVELER_ICON;
      res.push({
        type: "Feature",
        properties: cur,
        geometry: {
          type: "Point",
          coordinates: [cur.long, cur.lat],
        },
      });
    }
  }

  return res;
};

const _loadMapIcon = (map, id, src) => {
  let img = new Image();
  img.onload = () => {
    map.addImage(id, img);
  };
  img.src = src;
};

const _loadTravelerIcon = (map) => {
  _loadMapIcon(map, TRAVELER_ICON, TRAVELER.Icons.Map);
};

const _getPreference = (store, defaultValue, property, type) => {
  let preferences = store.getters[MODULE_PREFIX_USER + "preferences"];

  //if preference hasn't been set default value
  const gridsPropertyString = "grids." + type;
  if (
    !(
      lodashGet(preferences, gridsPropertyString) &&
      preferences.grids.travelTracker.hasOwnProperty(property)
    )
  ) {
    _savePreference(store, defaultValue, property, type);
  }

  if (
    lodashGet(preferences, gridsPropertyString) &&
    preferences.grids.travelTracker.hasOwnProperty(property)
  ) {
    return preferences.grids[type][property];
  }
  return null;
};

const _savePreference = (store, value, property, type) => {
  type = type ? type : "travelTracker";

  let preferences = lodashCloneDeep(
    store.getters[MODULE_PREFIX_USER + "preferences"]
  );
  preferences.grids = preferences.grids || {};
  preferences.grids[type] = preferences.grids[type] || {};
  preferences.grids[type][property] = value;

  if (preferences.grids[type].hasOwnProperty("levels")) {
    delete preferences.grids[type].levels;
  }

  store.dispatch(MODULE_PREFIX_USER + SAVE_PREFERENCES, preferences);
};
